var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { boundaryState } from '~/state/boundary';
import { addWindowEventListener, removeWindowEventListener, } from '~/utils/windowEventListen';
export function useBoundary() {
    var _a = __read(useRecoilState(boundaryState), 2), boundary = _a[0], setBoundary = _a[1];
    var _b = __read(useState({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
    }), 2), windowSize = _b[0], setWindowSize = _b[1];
    useEffect(function () {
        var handleWindowResize = function () {
            setWindowSize({
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,
            });
        };
        addWindowEventListener('resize', handleWindowResize);
        return function () {
            removeWindowEventListener('resize', handleWindowResize);
        };
    }, []);
    useEffect(function () {
        setBoundary({
            width: windowSize.innerWidth * 1.5,
            height: windowSize.innerHeight * 1.5,
        });
    }, [windowSize]);
    return boundary;
}
